export default __webpack_public_path__ + "static/media/mail.f751a9fb.svg";